// extracted by mini-css-extract-plugin
module.exports = {"alert":"Alert_alert__3d5YB","content":"Alert_content__1TN9O","info":"Alert_info__32Xfg","icon":"Alert_icon__3zUuL","success":"Alert_success__3B5Ra","error":"Alert_error__2x3-v"};